import { z } from "zod";
import { ProseSchema } from "./prose.js";
import { RubricDimensionSchema } from "./primitives.js";
/**
 * P5 Debrief output (docs/prompt_pack.md P5). Six sections, each with the
 * word ceiling named in the prompt. The scorecard section deliberately
 * carries NO score value of its own — only a dimension and the id of the
 * Assessment record it reports on. This is what "must reference recorded
 * assessment ids; no free-standing scores" means structurally: the debrief
 * cannot invent, duplicate, or drift from a score, because it never has a
 * score field to invent one in.
 */
function maxWords(limit) {
    return (value) => value.trim().split(/\s+/).filter(Boolean).length <= limit;
}
const ScorecardEntrySchema = z.strictObject({
    dimension: RubricDimensionSchema,
    assessment_id: z.string().min(1),
});
export const DebriefSchema = z.strictObject({
    session_id: z.string().min(1),
    what_was_actually_true: ProseSchema.refine(maxWords(120), { message: "must be <= 120 words" }),
    the_fork: ProseSchema.refine(maxWords(100), { message: "must be <= 100 words" }),
    process_vs_outcome: ProseSchema.refine(maxWords(80), { message: "must be <= 80 words" }),
    scorecard: z.array(ScorecardEntrySchema).length(6),
    the_one_thing: ProseSchema.refine(maxWords(60), { message: "must be <= 60 words" }),
    replay_hook: ProseSchema.refine(maxWords(40), { message: "must be <= 40 words" }),
});
//# sourceMappingURL=debrief.js.map